export namespace BacklogsHubDirectoryConstants {
    export const BACKLOG_DIRECTORY_ALL_DATA_PROVIDER = "ms.vss-work-web.backlogs-hub-directory-all-tab-data-provider";
    export const BACKLOG_DIRECTORY_MINE_DATA_PROVIDER = "ms.vss-work-web.backlogs-hub-directory-mine-tab-data-provider";
}